import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import { parseInt } from "lodash";
import tokenService from '../../Common/tokenDecoder';

export default {
    getAll,
    getEstatesByGroupID,
    getDivisionByEstateID,
    GetAllCashWorkType,
    GetUserRoles,
    GetActiveAspNetUser,
    SaveuserMappingData,
    searchUserMappings,
    deleteUserMapping,
    GetAllOperationEntityByGroupID

};

async function getAll() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllCashWorkType() {
    const response = await CommonGet('/api/CashPluckingRateMapping/GetAllCashWorkType', null);
    let cashWorkTypeArray = []
    for (let item of Object.entries(response.data)) {
        cashWorkTypeArray[item[1]["cashWorkTypeID"]] = item[1]["cashWorkTypeName"]
    }
    return cashWorkTypeArray;
}


async function getEstatesByGroupID(id) {
    var estateArray = [];
    let model = {
        groupID: id == undefined ? 0 : id.toString(),
        enityTypeID: "2"
    };
    const response = await CommonPost('/api/CashPluckingRateMapping/GetOperationEntityIDByEntityTypeIDandGroupID', null, model);
    for (let item of Object.entries(response.data)) {
        estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return estateArray;
}
async function GetAllOperationEntityByGroupID(id) {
var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return estateArray;
}

async function getDivisionByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return divisionArray;
}


async function GetUserRoles(id) {
    var roleArray = [];
    const response = await CommonGet('/api/UserRole/GetUserRole', 'operationEntityID=' + id);
    for (let item of Object.entries(response.data)) {
        roleArray[item[1]["aspNetRoleId"]] = item[1]["aspNetRoleName"]

    }
    return roleArray;
}

async function GetActiveAspNetUser(id) {
    var userArray = [];
    const response = await CommonGet('/api/UserRole/GetUser', 'userRoleID=' + id);
    for (let item of Object.entries(response.data)) {
        userArray[item[1]["aspNetUserId"]] = item[1]["userName"]
    }
    return userArray;
}

async function SaveuserMappingData(mappingArray){
   var result = await CommonPost('/api/UserMapping/SaveUserMappingData', null, mappingArray);
   return result;
}
async function searchUserMappings(model) {
    const response = await CommonPost('/api/UserMapping/GetUserMappingData', null, model);
    return response;
}

async function deleteUserMapping(model) {
    const response = await CommonPost('/api/UserMapping/deleteUserMappingData', null, model);
    return response;
}

